import { useAppSelector } from "../../store/index.ts";
import useDeviceOrientation from "../useDeviceOrientation.js";

// блок stream включает в себя chat и video

export default function useBlockHeight() {
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);
  const height = useAppSelector((state) => state.deviceSize.height);
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);
  const headerHeight = useAppSelector((state) => state.siteInfo.blockHeight.headerHeight);
  const chatHeaderHeight = useAppSelector((state) => state.siteInfo.blockHeight.chatHeaderHeight);
  const isLsm = useAppSelector((state) => state.deviceSize.isLsm);
  const { isHorizontal } = useDeviceOrientation();

  const getStreamHeight = (val) => {
    if (isFullScreen) return "100svh";
    if (!val) return "80svh";
    if (isLsm) {
      if (val < 890) return "890px";
    } else {
      if (val < 620) return "620px";
    }
    return val + "px";
  };

  const newHeightStream = height - headerHeight - chatHeaderHeight;

  const chatContentHeight = getStreamHeight(newHeightStream * 0.9);
  const mobileMaxHeight = isFullScreen || isHorizontal ? "100dvh" : "60dvh";

  const zoomContainerHeightStyle = { maxHeight: isMobile ? mobileMaxHeight : chatContentHeight };

  return { chatContentHeight, zoomContainerHeightStyle };
}
